<template>
    <section class="practice">
        <vue-snotify></vue-snotify>
        <div class="row">
            <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content add-content col-md-9 col-sm-12">
                <div class="material-box bg-white">
                    <div class="col-md-12 top-title">
                        <h3>Add User</h3>
                    </div>
                    <div class="col-md-12">
                        <div class="section-container section-with-top-border p-b-10 ">
                            <form class="form-horizontal fv-form fv-form-bootstrap" @submit.prevent="saveUser" method="post"
                                enctype="multipart/form-data">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="FirstName">First Name</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-user"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="FirstName" name="FirstName"
                                                    autocomplete="FirstName" placeholder="First Name"
                                                    v-model="userData.FirstName"
                                                    :state="$v.userData.FirstName.$dirty ? !$v.userData.FirstName.$error : null"
                                                    aria-describedby="input-1-live-feedback"
                                                    label="First Name"></b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <div class="form-group">
                                            <label for="LastName">Last Name:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-user"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="LastName" name="LastName"
                                                    autocomplete="LastName" placeholder="Last Name"
                                                    v-model="userData.LastName"
                                                    :state="$v.userData.LastName.$dirty ? !$v.userData.LastName.$error : null"
                                                    aria-describedby="input-1-live-feedback"
                                                    label="Last Name"></b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <div class="form-group">
                                            <label for="Prefix">Prefix:</label>
                                            <b-input-group prepend="@">
                                                <b-form-select id="Prefix" v-model="userData.Prefix"
                                                    :options="PrefixOptions" value-field="item"
                                                    :state="$v.userData.Prefix.$dirty ? !$v.userData.Prefix.$error : null"
                                                    text-field="item">
                                                </b-form-select>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <div class="form-group">
                                            <label for="Status">Status:</label>
                                            <b-input-group prepend="@">
                                                <b-form-select id="Status" v-model="userData.Status"
                                                    :options="StatusOptions" value-field="item"
                                                    :state="$v.userData.Status.$dirty ? !$v.userData.Status.$error : null"
                                                    text-field="item">
                                                </b-form-select>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <div class="form-group m-b-10">
                                            <label class="control-label">User Name:</label>
                                            <div class="input-group legend-input">
                                                <legend> Your email address will be used as your Username</legend>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="Password">Password:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-key"></i>
                                                </b-input-group-prepend>
                                                <b-form-input :type="pField" id="Password" name="Password"
                                                    autocomplete="Password"
                                                    v-model="userData.Password"
                                                    :state="$v.userData.Password.$dirty ? !$v.userData.Password.$error : null"
                                                    aria-describedby="input-1-live-feedback"
                                                    label="Password"></b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                            <input type="checkbox" class="m-l-10 m-t-10" @click="showPass"> Show the password
                                        </div>

                                        <div class="form-group">
                                            <label for="Email">Email:</label>
                                            <b-input-group prepend="@">
                                                <b-form-input type="email" id="Email" name="Email" autocomplete="Email"
                                                    placeholder="Email" v-model="userData.Email"
                                                    aria-describedby="input-1-live-feedback"
                                                    :state="$v.userData.Email.$dirty ? !$v.userData.Email.$error : null"
                                                    label="Email"></b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                                <span class="text-danger" v-if="emailErr != ''">{{ emailErr }}</span>
                                            </b-input-group>
                                        </div>

                                    <div class="mt-3">
                                            <div class="row text-right footer-btns">
                                                <router-link :to="{ name: 'view_dashboard_user' }"
                                                    class="btn btn-primary width-100 m-r-5"><i class="fa fa-arrow-left"></i>
                                                    Back </router-link>
                                                <button type="submit" class="btn width-100 btn-success ">Save</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="row"> 
                                                <div class="col-md-6 my-2" >
                                                <div class="btn btn-primary btn-file">
                                                    <i class="glyphicon glyphicon-folder-open"></i>
                                                    <span>Browse …</span>
                                                    <input type="file" ref="fileInput" @change="handleFileUpload" />
                                                </div>
                                                <img v-if="imagePreviewUrl || !imageAdded" :src="imagePreviewUrl || 'https://t4.ftcdn.net/jpg/05/49/98/39/360_F_549983970_bRCkYfk0P6PP5fKbMhZMIb07mCJ6esXL.jpg'" style="margin-top: 20px;" alt="Image Preview" class="img-fluid" />
                                                <button class="btn width-120 btn-danger" v-if="imagePreviewUrl" @click="removeImage" style="float: inline-end; margin-top: 10px;">Remove Image</button>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";

export default {
    name: "view_user",
    components: {
        practiceSidebar
    },
    mixins: [validationMixin],
    data() {
        return {
            isLoading: false,
            pField:"password",
            loginUser: {},
            emailErr: "",
            imagePreviewUrl: '',
            userData: {
                FirstName: "",
                LastName: "",
                Prefix: "",
                Status: "",
                Password: "",
                Email: "",
                image: null
            },
            StatusOptions: [
                { item: 'DC' },
                { item: 'CA' },
            ],
            PrefixOptions: [
                { item: "Dr." },
                { item: "Mr." },
                { item: "Mrs." },
                { item: "Ms." },
            ]
        }
    },
    validations: {
        userData: {

            FirstName: {
                required,
            },
            Email: {
                required, email
            },
            LastName: {
                required,
            },
            Status: {
                required,
            },
            Password: {
                required,
            },
            Prefix: {
                required
            }
        }
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];

            // Store the selected file
            this.userData.image = file;

            // Read the file and generate a preview URL
            const reader = new FileReader();
            reader.onload = () => {
                this.imagePreviewUrl = reader.result;
            };
            reader.readAsDataURL(file);
        },
        showPass(){
            this.pField = this.pField == 'password'?'text':'password';
        },
        removeImage() {
            this.imagePreviewUrl = '';
            this.userData.image = null;
            this.$refs.fileInput.value = '';
        },
        saveUser() {
            this.$v.userData.$touch()
            if (this.$v.userData.$anyError) {
                return;
            }
            userAPI.addClientFromDashboard({ ...this.userData, ...{ PracticeID: this.loginUser.PracticeID } },
                res => {
                    this.$showNotification(res.data, "success")
                    this.$router.push({ name: 'view_dashboard_user' });
                }, err => {
                    if (err.response.status == 410) {
                        this.emailErr = err.response.data.message.Email[0];
                    }
                })
        }
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userDetails'));
        this.loginUser = user;
        if(user.Status == 'DC' || user.Status == 'CA')
        {
            this.$router.push({name:'user_dashboard'});
        }
    },
}

</script>
<style>
.form-group .input-group {
    flex-wrap: nowrap;
}
.form-group label {
    padding: 0;
    font-weight: bold;
    display: inline-block;
    margin-bottom: 0.5rem;
}
</style>